import { Ref } from "preact/hooks";

import Navigable from "./Navigable";
import NavigationDirection from "./NavigationDirection";

export function manageNavigation(
    itemRefs: Ref<Navigable>[], direction: NavigationDirection, item?: Navigable, giveNavigation?: () => void
) {
    const visibleItems = itemRefs.map(({ current }) => current).filter(current => current?.mounted);
    let nextIndex: number;
    if (item) {
        const index = visibleItems.indexOf(item);
        nextIndex = direction === NavigationDirection.Up ? index - 1 : index + 1;
    } else {
        nextIndex = direction === NavigationDirection.Up ? visibleItems.length - 1 : 0;
    }

    if (nextIndex > -1 && nextIndex < visibleItems.length) {
        visibleItems[nextIndex].gainNavigation(direction);
    } else {
        giveNavigation?.();
    }
}
